import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import * as common from './commons/common'

const baseUrl = common.getApiUrl();

// 토큰 만료 확인
function isTokenExpired(token) {
    if (!token) return true;

    try {
        const [, payload] = token.split('.');
        if (!payload) return true;

        const decoded = JSON.parse(atob(payload));
        const currentTime = Date.now() / 1000;

        return decoded.exp < currentTime;
    } catch (error) {
        console.error("Error decoding token:", error);
        return true;
    }
}

// 토큰 갱신
async function refreshAccessToken(refreshToken) {
    try {
        const response = await axios.post(`${baseUrl}/auth/refresh-token`, { refreshToken });

        if (response.data !== undefined) {
            localStorage.setItem('access_token', response.data);
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Failed to refresh access token:', error);
        return null;
    }
}

function validationAuth(Component) {
    return function AuthenticatedComponent(props) {
        const [isLoading, setIsLoading] = useState(true);
        const [isAuthenticated, setIsAuthenticated] = useState(false);

        useEffect(() => {
            const validateAuth = async () => {
                const accessToken = localStorage.getItem('access_token');
                const refreshToken = localStorage.getItem('refresh_token');

                // refresh token이 없으면 홈으로 리다이렉트
                if (!refreshToken) {
                    setIsLoading(false);
                    return;
                }

                // access token이 없거나 만료된 경우
                if (!accessToken || isTokenExpired(accessToken)) {
                    console.log('토큰 갱신 시도 중...');

                    try {
                        const newAccessToken = await refreshAccessToken(refreshToken);

                        if (newAccessToken) {
                            console.log('토큰 갱신 성공');
                            setIsAuthenticated(true);
                        } else {
                            console.log('토큰 갱신 실패 - 로그인 페이지로 이동');
                            // refresh token도 만료된 경우 로컬스토리지 클리어
                            localStorage.clear();
                        }
                    } catch (error) {
                        console.error('토큰 갱신 중 오류:', error);
                        localStorage.clear();
                    }
                } else {
                    // 토큰이 유효한 경우
                    console.log('토큰 정상');
                    setIsAuthenticated(true);
                }

                setIsLoading(false);
            };

            validateAuth();
        }, []);

        // 로딩 중일 때 로딩 스피너 표시
        if (isLoading) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    flexDirection: 'column'
                }}>
                    <div style={{
                        border: '4px solid #f3f3f3',
                        borderTop: '4px solid #3498db',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        animation: 'spin 2s linear infinite',
                        marginBottom: '20px'
                    }}></div>
                    <p>인증 확인 중...</p>
                    <style>{`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}</style>
                </div>
            );
        }

        // 인증 실패 시 리다이렉트
        if (!isAuthenticated) {
            const refreshToken = localStorage.getItem('refresh_token');
            if (!refreshToken) {
                return <Navigate to="/" replace />;
            } else {
                return <Navigate to="/login" replace />;
            }
        }

        // 인증 성공 시 컴포넌트 렌더링
        return <Component {...props} />;
    };
}

export default validationAuth;